import { getIconProps, type IconProps } from '#types'

/**
 * Door icon — door panel with frame and handle.
 *
 * Used for access control pages and entry/door-related features.
 *
 * @example
 * ```tsx
 * <DoorIcon className="size-10" />
 * ```
 */
export function DoorIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M8 18.0605C4.44444 16.8105 4 17.0015 4 12.0605C4 7.11955 4.44444 7.31052 8 6.06055"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2041 4.43359C11.8267 4.00738 10.8822 3.92986 10.2354 4.05371C9.64771 4.16629 9.25024 4.45313 8.9375 4.96777C8.5952 5.53106 8.34699 6.38488 8.19531 7.60938C8.04524 8.82106 8 10.302 8 12.0605C8 13.8191 8.04524 15.3 8.19531 16.5117C8.34698 17.7362 8.59521 18.59 8.9375 19.1533C9.25024 19.668 9.6477 19.9548 10.2354 20.0674C10.8822 20.1912 11.8267 20.1137 13.2041 19.6875C14.6889 19.228 15.7568 18.9282 16.5967 18.6074C17.4218 18.2922 17.8713 18.0104 18.1621 17.6758C18.4441 17.3513 18.6674 16.8718 18.8096 15.9756C18.9539 15.0653 19 13.8274 19 12.0605C19 10.294 18.9539 9.05672 18.8096 8.14648C18.6674 7.25002 18.4442 6.76982 18.1621 6.44531C17.8713 6.11077 17.4217 5.82888 16.5967 5.51367C15.7568 5.19284 14.6889 4.89309 13.2041 4.43359Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8164 12.1818H11.3063"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
